import { Settings, FolderPlus, Trash2, FolderMinus, LogIn } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  DropdownMenuSeparator,
  DropdownMenuLabel,
} from "@/components/ui/dropdown-menu";
import { useI18n } from "@/lib/i18n";
import { useNavigate } from "react-router-dom";
import type { ConstructionSite } from "@/hooks/useProjects";

interface ChatActionsProps {
  chatId: string | null;
  currentSiteId?: string | null;
  sites: ConstructionSite[];
  isLoggedIn: boolean;
  onAssignChat: (chatId: string, siteId: string | null) => void;
  onDeleteChat: (chatId: string) => void;
}

export function ChatActions({ chatId, currentSiteId, sites, isLoggedIn, onAssignChat, onDeleteChat }: ChatActionsProps) {
  const { t } = useI18n();
  const navigate = useNavigate();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button className="p-1 rounded-full hover:bg-muted transition-colors text-muted-foreground hover:text-foreground">
          <Settings className="w-3.5 h-3.5" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" side="top" className="min-w-[180px]">
        {isLoggedIn && chatId && sites.length > 0 ? (
          <>
            <DropdownMenuLabel className="text-xs font-normal text-muted-foreground flex items-center gap-1.5">
              <FolderPlus className="w-3.5 h-3.5" />
              {t("chat.assignToProject")}
            </DropdownMenuLabel>
            {sites.map((site) => (
              <DropdownMenuItem
                key={site.id}
                onClick={() => onAssignChat(chatId, site.id)}
                className={`pl-7 ${currentSiteId === site.id ? "font-semibold" : ""}`}
              >
                {site.name}
              </DropdownMenuItem>
            ))}
            {currentSiteId && (
              <DropdownMenuItem onClick={() => onAssignChat(chatId, null)} className="pl-7 gap-2 text-muted-foreground">
                <FolderMinus className="w-3.5 h-3.5" />
                {t("chat.unassign")}
              </DropdownMenuItem>
            )}
            <DropdownMenuSeparator />
          </>
        ) : (
          <>
            <DropdownMenuItem onClick={() => navigate("/login")} className="gap-2">
              <LogIn className="w-3.5 h-3.5" />
              {t("chat.loginToSave")}
            </DropdownMenuItem>
            <DropdownMenuSeparator />
          </>
        )}
        <DropdownMenuItem
          onClick={() => onDeleteChat(chatId || "")}
          className="gap-2 text-destructive focus:text-destructive"
        >
          <Trash2 className="w-3.5 h-3.5" />
          {t("chat.deleteChat")}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
